import {
  ApplicationFeature,
  CurrentCompanyInfoDto,
  FormBaseType,
} from "@green0meter/api-client";

export type FormBaseTypeOption = {
  value: FormBaseType;
  label: string;
};

export const getAvailableFormBaseTypes = (
  currentCompany: CurrentCompanyInfoDto,
): FormBaseTypeOption[] => {
  const formBaseTypesForFeatures: { [key in ApplicationFeature]?: FormBaseType[] } =
    {
      [ApplicationFeature.CO2]: [FormBaseType.Co2],
      [ApplicationFeature.BRSR]: [FormBaseType.BRSR],
      [ApplicationFeature.VSME]: [FormBaseType.VSME],
      [ApplicationFeature.CSRD]: [FormBaseType.ESRS],
      [ApplicationFeature.CSOB_SK]: [FormBaseType.CsobSk],
      [ApplicationFeature.PROCUREMENT_SUPPLIER]: [FormBaseType.ProcurementSupplier],
    };

  const formBaseTypeOptions: FormBaseTypeOption[] = [];

  currentCompany.companyFeatureFunctionalities.forEach((feature) => {
    if (feature.applicationFeature !== undefined) {
      const formBaseTypes = formBaseTypesForFeatures[feature.applicationFeature];

      if (formBaseTypes) {
        for (const formBaseType of formBaseTypes) {
          formBaseTypeOptions.push({
            value: formBaseType,
            label: FormBaseType[formBaseType],
          });
        }
      }
    }
  });

  return formBaseTypeOptions;
};
